import { sendAnalytics } from 'src/utils/analytics';
import { getUtmParams } from 'src/utils/helpers';
import { UAParser } from 'ua-parser-js';
const parseResult = UAParser(navigator.userAgent);

export function useStatistics() {
  return {
    getDeviceType,
    getBrowserInfo,
    getOSInfo,
    getLocationByIP,
    getAll,
  };
}

async function getAll() {
  const locationInfo = await getLocationByIP();
  const utm = getUtmParams();
  if (Object.keys(utm).length === 0) {
    sendAnalytics('event', 'page_view');
  }
  // else { // for now leave as is, will refine and find a better way to handle UTM params later
  //   // let done = false;
  //   // const cleanUrl = () => {
  //   //   if (done) return;
  //   //   done = true;
  //   //   history.replaceState(null, '', location.origin + location.pathname + location.hash);
  //   // };
  //   // const timer = setTimeout(cleanUrl, 2000);
  //   // sendAnalytics('event', 'page_view', {
  //   //   ...utm,
  //   //   page_location: location.href,
  //   //   event_callback: () => {
  //   //     clearTimeout(timer);
  //   //     cleanUrl();
  //   //   },
  //   //   event_timeout: 2000,
  //   // });
  // }
  return {
    deviceType: getDeviceType(),
    browserInfo: getBrowserInfo(),
    osInfo: getOSInfo(),
    locationInfo,
    referrerURL: document.referrer,
    screenResolution: getScreenResolution(),
    viewportSize: getViewportSize(),
    language: navigator.language || (navigator as unknown as { userLanguage: string }).userLanguage,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ip: locationInfo === 'Unknown' ? 'Unknown' : locationInfo.ip,
    utmSource: utm.utm_source,
    utmMedium: utm.utm_medium,
    utmCampaign: utm.utm_campaign,
    utmTerm: utm.utm_term,
    utmContent: utm.utm_content,
  } as Statistics;
}

function getScreenResolution() {
  return `${window.screen.width}x${window.screen.height}`;
}

function getViewportSize() {
  return `${window.innerWidth}x${window.innerHeight}`;
}

function getDeviceType() {
  const deviceType = parseResult.device.type || 'desktop'; // console, mobile, tablet, smarttv, wearable, embedded
  return deviceType;
}

function getBrowserInfo() {
  return parseResult.browser.name || 'Unknown';
}

function getOSInfo() {
  return parseResult.os.name || 'Unknown';
}
export async function getLocationByIP() {
  try {
    const result = await fetch('https://ipv4.geojs.io/v1/ip/geo.json').then((res) => res.json());
    return {
      ip: result.ip,
      country: result.country,
      countryCode: result.country_code,
      latitude: result.latitude,
      longitude: result.longitude,
      timezone: result.timezone,
    };
  } catch (error) {
    return 'Unknown';
  }
}
export interface Statistics {
  deviceType: string;
  browserInfo: string;
  osInfo: string;
  locationInfo: LocationInfo;
  ip: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent: string;
}

interface LocationInfo {
  ip: string;
  country: string;
  countryCode: string;
  latitude: string;
  longitude: string;
  timezone: string;
}
